import { Injectable } from '@angular/core';
import { ApiService } from './api';

import { HorseNomination } from '../model/horseNomination';
import { NominationHorseSlot } from 'model/nominationHorseSlot';

@Injectable()
export class NominationService {
    deleted: number[] = [];

    constructor(private api: ApiService) { }

    getHorseNominations(accountId) { 
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.nominations + '/getHorseNomination' + '?accountId=' + accountId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addHorseNomination(accountId : number, nomination: HorseNomination, pay: boolean) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.nominations + `/addHorseNominationStaff?accountId=${accountId}&pay=${pay}`, nomination)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateHorseNomination(nomination: HorseNomination) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.nominations + '/updateHorseNomination', nomination)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteHorseNomination(accountId: number, nominationId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.nominations + '/removeHorseNomination?accountId=' + accountId + '&nominationId=' + nominationId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getNominationLogs(nominationId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.nominations + '/getNominationLogs' + '?nominationId=' + nominationId)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getUpatedHorseNominations(nominationId: number, currentNominations) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.nominations + '/getUpatedHorseNominations?nominationId=' + nominationId, currentNominations)
                .then(data => resolve(data), error => reject(error));
        });
    }

    addNominationHorseSlot(nominationHorseSlot: NominationHorseSlot) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.nominations + '/create', nominationHorseSlot)
                .then(data => resolve(data), error => reject(error));
        });
    }

    updateNominationHorseSlot(nominationHorseSlot: NominationHorseSlot) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.nominations + '/update', nominationHorseSlot)
                .then(data => resolve(data), error => reject(error));
        });
    }

    deleteNominationHorseSlot(nominationHorseSlot: NominationHorseSlot) {
        return new Promise((resolve, reject) => {
            this.api
                .deleteWithAuth(this.api.endpoints.nominations + '/delete' + nominationHorseSlot)
                .then(data => resolve(data), error => reject(error));
        });
    }

    getNominationHorseSlotLogs(nominationId: number) {
        return new Promise((resolve, reject) => {
            this.api
                .getWithAuth(this.api.endpoints.nominations + '/getNominationLogs' + '?nominationId=' + nominationId)
                .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/nomination.service.ts